import React from 'react';

import './footer.css';


const Footer = () => {
    return(
        <div className="footerContainer">
            <div className="row">
                <div className="col-sm-12">
                    <div className="copyright-box">
                        <p className="copyright">&copy; Copyright 2021 <strong>Busari Benjamin</strong>. All Rights Reserved</p>
                    </div>
                </div>
            </div>
      </div>
    )
}
export default Footer;